export function vhToPixels(vh: string) {
    // Get the viewport height in pixels
    let viewportHeight = 0;
    if (typeof window !== 'undefined') {
        viewportHeight = window.innerHeight;
    }

    return (parseInt(vh) / 100) * viewportHeight;
}
